export default __webpack_public_path__ + "static/media/peterpan.cb2c0295.png";